/* eslint-disable no-mixed-spaces-and-tabs */
import { createContext, useContext } from 'react';

const INITIAL_CONTEXT = {
	selectedItems: [],
	setSelectedItems: (e) => [],
	expandedItems: [],
	setExpandedItems: (e) => [],
	disabled: false,
};

export const RiskClassSelectContext = createContext(INITIAL_CONTEXT);

export const useRiskClassSelectContext = () => {
	const context = useContext(RiskClassSelectContext);
	if (!context) {
		throw new Error(
			'useRiskClassSelectContext must be used within a RiskClassSelectContextProvider'
		);
	}
	return context;
};
